<template>
  <div id="app">
    <router-view></router-view>
  </div>
    
</template>

<script>

export default {
 
}
</script>

<style>
#app {
  background-color: #f2f2f2;
}
.active {
    color: #00d2a5 !important;
  }
</style>
